import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Submissionhero from './Submissionhero'
import Submit from './Submit'

const Submission = () => {
  return (
    <div>
        <Header />
        <Submissionhero />
        <Submit />
        <br />
        <br />
        <Footer />
    </div>
  )
}

export default Submission